import { render, staticRenderFns } from "./EducationProgramsManagement.vue?vue&type=template&id=35088980"
import script from "./EducationProgramsManagement.vue?vue&type=script&lang=js"
export * from "./EducationProgramsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports